import { render, staticRenderFns } from "./AddSPMPage.vue?vue&type=template&id=851a788c&scoped=true&"
import script from "./AddSPMPage.vue?vue&type=script&lang=js&"
export * from "./AddSPMPage.vue?vue&type=script&lang=js&"
import style0 from "./AddSPMPage.vue?vue&type=style&index=0&id=851a788c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a788c",
  null
  
)

export default component.exports